
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Blog from '../pages/blog/page';
import BlogPost from '../pages/blog/post';
import Contact from '../pages/contact/page';
import Careers from '../pages/careers/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/blog',
    element: <Blog />
  },
  {
    path: '/blog/:slug',
    element: <BlogPost />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/careers',
    element: <Careers />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
